export default __webpack_public_path__ + "static/media/Twitter-login-logo.78c6a731.jpg";